var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoiceMain" },
    [
      _c("div", { staticClass: "topView" }, [
        _vm.companyInfo
          ? _c("div", { staticClass: "topTitle" }, [
              _c("span", [_vm._v("可用授信额度")]),
              _c("div", { staticClass: "topMoney" }, [
                _vm._v(
                  "¥" + _vm._s(_vm.fixtoTwo(_vm.companyInfo.availableQuota))
                ),
              ]),
              _c("span", { staticClass: "topDetail" }, [
                _vm._v(
                  "总授信额度：¥" + _vm._s(_vm.fixtoTwo(_vm.companyInfo.quota))
                ),
              ]),
            ])
          : _vm._e(),
        _vm.totalAmountData
          ? _c("div", { staticClass: "topTitle" }, [
              _c("span", [_vm._v("已开具金额")]),
              _c("span", { staticClass: "topMoney" }, [
                _vm._v(
                  "¥" + _vm._s(_vm.fixtoTwo(_vm.totalAmountData.totalAmount))
                ),
              ]),
              _c("span", { staticClass: "topDetail" }, [
                _vm._v(
                  "累计税额：¥" +
                    _vm._s(_vm.fixtoTwo(_vm.totalAmountData.taxAmount)) +
                    " "
                ),
                _c("span", [
                  _vm._v("发票：" + _vm._s(_vm.totalAmountData.total) + " 张"),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "selectView" },
        [
          _c("el-input", {
            staticStyle: { width: "180px" },
            attrs: { size: "small", placeholder: "请输入客户名称/发票" },
            model: {
              value: _vm.formTool.clinicName,
              callback: function ($$v) {
                _vm.$set(_vm.formTool, "clinicName", $$v)
              },
              expression: "formTool.clinicName",
            },
          }),
          _c("div", { staticStyle: { width: "8px" } }),
          _c(
            "el-select",
            {
              attrs: { size: "small" },
              model: {
                value: _vm.formTool.invoiceType,
                callback: function ($$v) {
                  _vm.$set(_vm.formTool, "invoiceType", $$v)
                },
                expression: "formTool.invoiceType",
              },
            },
            _vm._l(_vm.invoiceTypeList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.codeText, value: item.codeValue },
              })
            }),
            1
          ),
          _c("div", { staticStyle: { width: "8px" } }),
          _c("div", { staticStyle: { width: "8px" } }),
          _c("el-date-picker", {
            ref: "datePicker",
            attrs: {
              type: "daterange",
              "unlink-panels": "",
              size: "small",
              "range-separator": "-",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "picker-options": _vm.pickerOptions,
              clearable: false,
            },
            on: { change: _vm.didSelectDate },
            model: {
              value: _vm.timeRange,
              callback: function ($$v) {
                _vm.timeRange = $$v
              },
              expression: "timeRange",
            },
          }),
          _c("div", { staticStyle: { width: "8px" } }),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { size: "small", type: "default", plain: "" },
              on: {
                click: function ($event) {
                  return _vm.reset()
                },
              },
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.query()
                },
              },
            },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { ref: "tblContainer", staticClass: "tblView" },
        [
          _c(
            "div",
            { staticClass: "btnArr" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { size: "small", type: "default", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.addDialog = true
                    },
                  },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
          _vm.tblHeight
            ? _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.dataList, "max-height": _vm.getTblHeight },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "发票总类" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getLocalOfficeName(
                                      scope.row.invoiceType
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      466031410
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "taxDate", label: "开票日期" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "taxNumber", label: "发票号码" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "customerName", label: "客户名称" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "合计金额" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.fixtoTwo(scope.row.excludingTaxAmount)
                                    )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      994784331
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "taxRate", label: "税率" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.getTaxtRate(scope.row.taxRate)) + "%"
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2053451152
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "合计税额" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(_vm.fixtoTwo(scope.row.taxAmount))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3357752136
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "价税合计" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(_vm.fixtoTwo(scope.row.totalAmount))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      530942439
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作", width: "66" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "editBtn",
                                  attrs: { type: "text" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.lookPdf(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4060494262
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("Pagination", {
            attrs: {
              total: _vm.page.total,
              "page-sizes": _vm.page.pageSizes,
              page: _vm.page.current,
              limit: _vm.page.size,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.page, "current", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.page, "size", $event)
              },
              pagination: _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.addDialog, title: "立即开票", width: "520px" },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
          },
        },
        [
          _c("InvoiceDialog", {
            on: {
              cancelAddDialog: _vm.cancelAddDialog,
              addSureAction: _vm.addSureAction,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.pdfDialog, title: "发票详情" },
          on: {
            "update:visible": function ($event) {
              _vm.pdfDialog = $event
            },
          },
        },
        [
          _vm.pdfUrl
            ? _c("iframe", {
                staticStyle: { width: "100%", height: "500px" },
                attrs: {
                  src: "data:application/pdf;base64," + _vm.pdfUrl,
                  frameborder: "0",
                },
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }